import { ReactNode } from 'react';
import { withStyles } from 'vopay';
import { motion, AnimatePresence } from 'motion/react';
import styles from './SettingsGroup.module.scss';

const cn = withStyles(styles);

type SettingsGroupProps = {
  children: ReactNode;
  className?: string;
};

export default function SettingsGroup({ children, className }: SettingsGroupProps) {
  return (
    <motion.div layout className={cn('settingsGroup', className)}>
      <AnimatePresence initial={false} mode="popLayout">
        {children}
      </AnimatePresence>
    </motion.div>
  );
}

type SettingsHeaderProps = {
  children: ReactNode;
  className?: string;
};

function SettingsHeader({ children, className }: SettingsHeaderProps) {
  return <div className={cn('settingsHeader', className)}>{children}</div>;
}

SettingsGroup.Header = SettingsHeader;

type SettingsRowProps = {
  children: ReactNode;
  className?: string;
};

function SettingsRow({ children, className }: SettingsRowProps) {
  return (
    <motion.div
      layout
      className={cn('settingsRow', className)}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{
        opacity: 1,
        scale: 1,
        transition: {
          duration: 0.2,
          ease: 'easeOut',
        },
      }}
      exit={{
        opacity: 0,
        scale: 0.8,
        transition: {
          duration: 0.15,
          ease: 'easeIn',
        },
      }}
    >
      {children}
    </motion.div>
  );
}

SettingsGroup.Row = SettingsRow;
